// extracted by mini-css-extract-plugin
module.exports = {"item":"Item5_item__247cH","active":"Item5_active__39QvK","head":"Item5_head__rBYbt","body":"Item5_body__3Y97c","button":"Item5_button__2iAZa"};